import React, { useContext } from 'react'
import { AuthContext } from "@app/providers";
import { user } from '@app/utils';
import { LoggedUserName, SignUpBtn } from '@app/components/commonStyles/common-components';

export default function WFname() {
    const { userInfo }: any = useContext(AuthContext);
    return (
        <>
            <div className="signUp-iframe">

                <SignUpBtn className={userInfo ? 'user-logged-in' : ''} href={userInfo ? "/profile" : "/sign-up"} target="_blank">
                    {userInfo ? (userInfo.userJson.firstName + ' ' + userInfo.userJson.lastName) : 'Sign Up'}
                </SignUpBtn>
            </div>
        </>
    )
}